import { Component, OnDestroy, OnInit } from "@angular/core";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { ContactUsService } from "./contact-us.service";

@Component({
  template: `<app-contact-us [retailerInfo]="retailerInfo"></app-contact-us> `,
  styles: [],
})
export class ContactUsSmartComponent
  extends FeaturesBaseComponent
  implements OnInit, OnDestroy
{
  retailerInfo: any = {};
  constructor(private contactService: ContactUsService) {
    super();
    this.retailerInfo = {};
    // this.contactService.getRetailerContactDetails().subscribe(res => {
    //   if(res['httpcode'] == 200){
    //     this.retailerInfo = res['data']
    //   }
    // })
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
